module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_05_PrncOThv_5R.d46c0f02.png";